import {
    PRODUCT_COMPREHENSIVE_CAR, PRODUCT_BLING, PRODUCT_PORTABLE_POSSESSIONS, PRODUCT_CAR_WARRANTY, PRODUCT_CHILLI, SET_QUOTE_DATA, SET_IVERI_DATA, START_NEW_SALE, NEW_QUOTE_CAR, RESET_QUOTE_DATA, SET_STEPS_CODE_RED, PRODUCT_CODE_RED, SET_STEPS_WARRANTY,
    PRODUCT_BUILDING, PRODUCT_HOME_CONTENT, SET_STEPS_BUILDING, SET_STEPS_HOME_CONTENT, SET_STEPS_BUILDING_PARTIAL, SET_STEPS_HOME_CONTENT_PARTIAL
} from './../constants/constants';
import { AdminJudgementAnswerSet, AdminJudgementQuestion } from '../interfaces/Legal/legalInterfaces'

const emptyAdmin: AdminJudgementQuestion[] = [];
const emptyAnswers: AdminJudgementAnswerSet = {
    adminJudgementAnswers: [],
    secondaryAdminJudgementAnswers: [],
}

const initialState = {
    addProduct: "",
    product: "",
    KPCID: "",
    quote: {},
    carDetails: {},
    name: "",
    surname: "",
    cellphoneNumber: "",
    email: "",
    idNumber: "",
    itcConsent: false,
    mobileClientInfoStatus: "",
    policyId: "",
    customerId: "",
    quoteNumber: "",
    policyNumber: "",
    lmsStatus: false,
    bucketKey: "",
    referenceKey: "",
    vehicleFullDescription: "",
    vehicleYear: "",
    vehicleMakeId: "",
    vehicleModelId: "",
    vehicleSeriesId: "",
    mmCode: "",
    regNr: "",
    vinNumber: "",
    engineNumber: "",
    financed: undefined,
    financeHouse: "",
    financeHouseId: -1,
    addresses: [],
    addressId: null,
    addressDetail: { province: null, city: null, suburb: null, postalCode: null, formatted: null },
    address: "",
    lat: 0.00,
    lon: 0.00,
    regularDriver: "",
    regularDriverOtherName: "",
    regularDriverOtherSurname: "",
    regularDriverOtherIdNumber: "",
    regularDriverRelationship: "",
    quoteId: "",
    maritalStatus: '',
    carRisk: '',
    lastClaim: '',
    driversLicense: "",
    driversLicenseDate: "",
    selectedExcess: "",
    excessList: [],
    carPremium: "0.00",
    proRata: "0.00",
    carId: "",
    coverId: "",
    carHireOptions: null,
    balloonOptions: null,
    magsAndRims: "",
    smashAndGrab: "",
    sunroof: "",
    leatherSeats: "",
    otherAccessory: "",
    bullbar: "",
    canopy: "",
    accessoryValue: 0,
    carHire: null,
    creditShortfall: null,
    kingsCab: null,
    littleDingsAndTyreThings: null,
    scratchAndDent: null,
    tyreAndRim: null,
    tyreAndRimOptions: null,
    littleDingsOptions: null,
    firebaseToken: "",
    iveriSubmissionUrl: "",
    bankOptions: "",
    branchOptions: "",
    debitOrderDate: 1,
    isNewItem: true,
    hadBullbar: false,
    hadCanopy: false,
    hadCarRims: false,
    hadLeatherSeats: false,
    hadOtherAccesories: false,
    hadSmashGrab: false,
    hadSunroof: false,
    hadCarHire: false,
    hadCreditShortfall: false,
    hadKingsCab: false,
    hadLittleDingsAndTyreThings: false,
    hadScratchAndDent: false,
    hadTyreAndRim: false,
    isInEdit: false,
    totalPremium: "0.00",
    hadRafAssist: false,
    rafAssist: null,
    showRafAssist: false,
    selectedDriver: "",
    quoteType: "",
    portablePossessionTypeId: "",
    portablePossessionType: "",
    portablePossessionDescription: "",
    replacementCheckResult: "",
    replacementValue: 0,
    startReplacementValue: 0,
    MaxReplacementValue: 0,
    MinReplacementValue: 0,
    portablePossessionRisk: '',
    portablePossessionlastClaim: '',
    portableItemDetails: null,
    riskItemPhonenumber: "",
    portablePossessionMakeId: "",
    portablePossessionModelId: "",
    portablePossessionMemoryTypeId: "",
    adminJudgementQuestions: emptyAdmin,
    adminJudgementAnswerSet: emptyAnswers,
    selectedPortableDetail: "",
    selectedBlingDetail: "",
    blingPremiums: [],
    referralResponse: "",
    validationErrorLegalQuestions: true,
    blingTypeId: 2,
    blingType: "",
    blingDescription: "",
    blingRisk: '',
    blingItemDetails: null,
    blingMakeId: "",
    cellPhoneMemoryTypeId: "",
    cellPhoneModelId: "",
    cellPhoneMakeId: "",
    serialNumber: "",
    cellPhoneInitials: "",
    cellPhoneSurname: "",
    inceptionDate: "",
    firstPremium: "",
    firstPremiumType: "",
    firstPremiumDate: "",
    premiumTotal: "",
    bankName: "",
    accountNumber: "",
    bankError: false,
    bankAccountTypeId: "",
    bankId: "",
    branchId: "",
    isQuoteScreen: false,
    quoteScreenRiskId: "",
    quoteScreenRiskDescription: "",
    acceptedBlingCovers: [],
    addedBlingNumbers: [],
    acceptBlingQuote: null,
    isIMEINumberActive: false,
    iMEINumber: "",
    gender: null,
    regularDriverGender: null,
    sourceOfIncomeId: null,
    quoteCancellationReasons: null,
    primaryQuoteCancellationReason: null,
    secondaryQuoteCancellationReason: null,
    updatedPremium: null,
    creditAmount: null,
    isInRemove: false,
    protectiveCase: 2,
    saleStep: 0,
    saleSubStep: 0,
    selectedSalesStep: { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: "Personal info", subTitle: "We need a few details" },
    salesStepConfiguration: {
        steps:
            []
    },
    nextSalesStep: 0,
    nextSalesSubStep: 0,
    lastCompletedStep: 0,
    lastCompletedSubStep: 0,
    carColor: null,
    codeRedSelectedRiskitem: "",
    kilometersOnCar: 0,
    averageKilometers: 0,
    carRegisteredLocally: undefined,
    performanceModification: undefined,
    fullServiceHistory: undefined,
    existingWarranty: undefined,
    selectedAgreedValue: undefined,
    selectedAgreedValuePercentage: 0,
    warrantyBenefits: [],
    carWarrantyValueDisplay: "",
    carWarrantyMaxMilage: "",
    buildingLiving:'',
    buildingOwner: false,
    buildingStorage: false,
    buildingUse: "",
    buildingAge: -1,
    buildingAdditional: { thatchRoof: false, thatchLapa: false, alternativePower: false, woodenWalls: false },
    buildingAdditionalDetail: { thatch_lightningConductor: false, thatch_fireExtinguisher: false, thatch_fireRetardantTreatment: false, thatch_harveyTiles: false, thatch_distanceBetween: null, alternativePower_replacementValue: null },
    buildingInfo: { bedrooms: 0, geysers: 0, securityEstate: false, armedResponse: false, burglarBars: false, electricFence: false },
    propertyBorders: { field: false, river: false, informalSettlement: false, farmPlot: false },
    requiresReferral: false,
    currentlyInsured: undefined,
    claimsCount: undefined,
    claimsSelection: undefined,
    claimsHistory: [],
    buildingRating: "",
    buildingReplacementValue: undefined,
    buildingContinueQuote: false,
}

const salesReducer = (state = initialState, action) => {
    switch (action.type) {
        case PRODUCT_COMPREHENSIVE_CAR:
            return {
                ...state,
                addProduct: PRODUCT_COMPREHENSIVE_CAR,
                quoteType: PRODUCT_COMPREHENSIVE_CAR
            }
        case PRODUCT_PORTABLE_POSSESSIONS:
            return {
                ...state,
                addProduct: PRODUCT_PORTABLE_POSSESSIONS,
                quoteType: PRODUCT_PORTABLE_POSSESSIONS
            }
        case PRODUCT_CAR_WARRANTY:
            return {
                ...state,
                addProduct: PRODUCT_CAR_WARRANTY,
                quoteType: PRODUCT_CAR_WARRANTY
            }
        case PRODUCT_CHILLI:
            return {
                ...state,
                addProduct: PRODUCT_CHILLI,
                quoteType: PRODUCT_CHILLI
            }
        case PRODUCT_BLING:
            return {
                ...state,
                addProduct: PRODUCT_BLING,
                quoteType: PRODUCT_BLING
            }
        case PRODUCT_CODE_RED:
            return {
                ...state,
                addProduct: PRODUCT_CODE_RED,
                quoteType: PRODUCT_CODE_RED
            }
        case PRODUCT_BUILDING:
            return {
                ...state,
                addProduct: PRODUCT_BUILDING,
                selectedExcess: "12345.67",
                carPremium: "1234.56",
                quoteType: PRODUCT_BUILDING
            }
        case PRODUCT_HOME_CONTENT:
            return {
                ...state,
                addProduct: PRODUCT_HOME_CONTENT,
                selectedExcess: "12345.67",
                carPremium: "1234.56",
                quoteType: PRODUCT_HOME_CONTENT
            }
        case SET_QUOTE_DATA:
            return {
                ...state,
                addProduct: ('addProduct' in action.payload) ? action.payload.addProduct : state.addProduct,
                email: ('email' in action.payload) ? action.payload.email : state.email,
                idNumber: ('idNumber' in action.payload) ? action.payload.idNumber : state.idNumber,
                name: ('name' in action.payload) ? action.payload.name : state.name,
                surname: ('surname' in action.payload) ? action.payload.surname : state.surname,
                cellphoneNumber: ('cellphoneNumber' in action.payload) ? action.payload.cellphoneNumber : state.cellphoneNumber,
                itcConsent: ('itcConsent' in action.payload) ? action.payload.itcConsent : state.itcConsent,
                mobileClientInfoStatus: ('mobileClientInfoStatus' in action.payload) ? action.payload.mobileClientInfoStatus : state.mobileClientInfoStatus,
                policyId: ('policyId' in action.payload) ? action.payload.policyId : state.policyId,
                quoteId: ('quoteId' in action.payload) ? action.payload.quoteId : state.quoteId,
                customerId: ('customerId' in action.payload) ? action.payload.customerId : state.customerId,
                quoteNumber: ('quoteNumber' in action.payload) ? action.payload.quoteNumber : state.quoteNumber,
                policyNumber: ('policyNumber' in action.payload) ? action.payload.policyNumber : state.policyNumber,
                lmsStatus: ('lmsStatus' in action.payload) ? action.payload.lmsStatus : state.lmsStatus,
                bucketKey: ('bucketKey' in action.payload) ? action.payload.bucketKey : state.bucketKey, 
                referenceKey: ('referenceKey' in action.payload) ? action.payload.referenceKey : state.referenceKey, 
                vehicleFullDescription: ('vehicleFullDescription' in action.payload) ? action.payload.vehicleFullDescription : state.vehicleFullDescription,
                vehicleYear: ('vehicleYear' in action.payload) ? action.payload.vehicleYear : state.vehicleYear,
                vehicleMakeId: ('vehicleMakeId' in action.payload) ? action.payload.vehicleMakeId : state.vehicleMakeId,
                vehicleModelId: ('vehicleModelId' in action.payload) ? action.payload.vehicleModelId : state.vehicleModelId,
                vehicleSeriesId: ('vehicleSeriesId' in action.payload) ? action.payload.vehicleSeriesId : state.vehicleSeriesId,
                mmCode: ('mmCode' in action.payload) ? action.payload.mmCode : state.mmCode,
                regNr: ('regNr' in action.payload) ? action.payload.regNr : state.regNr,
                financed: ('financed' in action.payload) ? action.payload.financed : state.financed,
                financeHouse: ('financeHouse' in action.payload) ? action.payload.financeHouse : state.financeHouse,
                financeHouseId: ('financeHouseId' in action.payload) ? action.payload.financeHouseId : state.financeHouseId,
                addresses: ('addresses' in action.payload) ? action.payload.addresses : state.addresses,
                addressId: ('addressId' in action.payload) ? action.payload.addressId : state.addressId,
                addressDetail: ('addressDetail' in action.payload) ? action.payload.addressDetail : state.addressDetail,
                address: ('address' in action.payload) ? action.payload.address : state.address,
                lat: ('lat' in action.payload) ? action.payload.lat : state.lat,
                lon: ('lon' in action.payload) ? action.payload.lon : state.lon,
                regularDriver: ('regularDriver' in action.payload) ? action.payload.regularDriver : state.regularDriver,
                regularDriverOtherName: ('regularDriverOtherName' in action.payload) ? action.payload.regularDriverOtherName : state.regularDriverOtherName,
                regularDriverOtherSurname: ('regularDriverOtherSurname' in action.payload) ? action.payload.regularDriverOtherSurname : state.regularDriverOtherSurname, lastCompletedStep: 0,
                regularDriverOtherIdNumber: ('regularDriverOtherIdNumber' in action.payload) ? action.payload.regularDriverOtherIdNumber : state.regularDriverOtherIdNumber,
                regularDriverRelationship: ('regularDriverRelationship' in action.payload) ? action.payload.regularDriverRelationship : state.regularDriverRelationship,
                maritalStatus: ('maritalStatus' in action.payload) ? action.payload.maritalStatus : state.maritalStatus,
                carRisk: ('carRisk' in action.payload) ? action.payload.carRisk : state.carRisk,
                portablePossessionRisk: ('portablePossessionRisk' in action.payload) ? action.payload.portablePossessionRisk : state.portablePossessionRisk,
                lastClaim: ('lastClaim' in action.payload) ? action.payload.lastClaim : state.lastClaim,
                driversLicense: ('driversLicense' in action.payload) ? action.payload.driversLicense : state.driversLicense,
                driversLicenseDate: ('driversLicenseDate' in action.payload) ? action.payload.driversLicenseDate : state.driversLicenseDate,
                selectedExcess: ('selectedExcess' in action.payload) ? action.payload.selectedExcess : state.selectedExcess,
                excessList: ('excessList' in action.payload) ? action.payload.excessList : state.excessList,
                quote: ('quote' in action.payload) ? action.payload.quote : state.quote,
                carDetails: ('carDetails' in action.payload) ? action.payload.carDetails : state.carDetails,
                carPremium: ('carPremium' in action.payload) ? action.payload.carPremium : state.carPremium,
                proRata: ('proRata' in action.payload) ? action.payload.proRata : state.proRata,
                carId: ('carId' in action.payload) ? action.payload.carId : state.carId,
                coverId: ('coverId' in action.payload) ? action.payload.coverId : state.coverId,
                carHireOptions: ('carHireOptions' in action.payload) ? action.payload.carHireOptions : state.carHireOptions,
                balloonOptions: ('balloonOptions' in action.payload) ? action.payload.balloonOptions : state.balloonOptions,
                magsAndRims: ('magsAndRims' in action.payload) ? action.payload.magsAndRims : state.magsAndRims,
                smashAndGrab: ('smashAndGrab' in action.payload) ? action.payload.smashAndGrab : state.smashAndGrab,
                sunroof: ('sunroof' in action.payload) ? action.payload.sunroof : state.sunroof,
                leatherSeats: ('leatherSeats' in action.payload) ? action.payload.leatherSeats : state.leatherSeats,
                otherAccessory: ('otherAccessory' in action.payload) ? action.payload.otherAccessory : state.otherAccessory,
                bullbar: ('bullbar' in action.payload) ? action.payload.bullbar : state.bullbar,
                canopy: ('canopy' in action.payload) ? action.payload.canopy : state.canopy,
                accessoryValue: ('accessoryValue' in action.payload) ? action.payload.accessoryValue : state.accessoryValue,
                carHire: ('carHire' in action.payload) ? action.payload.carHire : state.carHire,
                creditShortfall: ('creditShortfall' in action.payload) ? action.payload.creditShortfall : state.creditShortfall,
                kingsCab: ('kingsCab' in action.payload) ? action.payload.kingsCab : state.kingsCab,
                littleDingsAndTyreThings: ('littleDingsAndTyreThings' in action.payload) ? action.payload.littleDingsAndTyreThings : state.littleDingsAndTyreThings,
                scratchAndDent: ('scratchAndDent' in action.payload) ? action.payload.scratchAndDent : state.scratchAndDent,
                tyreAndRim: ('tyreAndRim' in action.payload) ? action.payload.tyreAndRim : state.tyreAndRim,
                tyreAndRimOptions: ('tyreAndRimOptions' in action.payload) ? action.payload.tyreAndRimOptions : state.tyreAndRimOptions,
                littleDingsOptions: ('littleDingsOptions' in action.payload) ? action.payload.littleDingsOptions : state.littleDingsOptions,
                bankOptions: ('bankOptions' in action.payload) ? action.payload.bankOptions : state.bankOptions,
                branchOptions: ('littleDingsOptions' in action.payload) ? action.payload.branchOptions : state.branchOptions,
                debitOrderDate: ('debitOrderDate' in action.payload) ? action.payload.debitOrderDate : state.debitOrderDate,
                isNewItem: ('isNewItem' in action.payload) ? action.payload.isNewItem : state.isNewItem,
                hadBullbar: ('hadBullbar' in action.payload) ? action.payload.hadBullbar : state.hadBullbar,
                hadCanopy: ('hadCanopy' in action.payload) ? action.payload.hadCanopy : state.hadCanopy,
                hadCarRims: ('hadCarRims' in action.payload) ? action.payload.hadCarRims : state.hadCarRims,
                hadLeatherSeats: ('hadLeatherSeats' in action.payload) ? action.payload.hadLeatherSeats : state.hadLeatherSeats,
                hadOtherAccesories: ('hadOtherAccesories' in action.payload) ? action.payload.hadOtherAccesories : state.hadOtherAccesories,
                hadSmashGrab: ('hadSmashGrab' in action.payload) ? action.payload.hadSmashGrab : state.hadSmashGrab,
                hadSunroof: ('hadSunroof' in action.payload) ? action.payload.hadSunroof : state.hadSunroof,
                hadCarHire: ('hadCarHire' in action.payload) ? action.payload.hadCarHire : state.hadCarHire,
                hadCreditShortfall: ('hadCreditShortfall' in action.payload) ? action.payload.hadCreditShortfall : state.hadCreditShortfall,
                hadKingsCab: ('hadKingsCab' in action.payload) ? action.payload.hadKingsCab : state.hadKingsCab,
                hadLittleDingsAndTyreThings: ('hadLittleDingsAndTyreThings' in action.payload) ? action.payload.hadLittleDingsAndTyreThings : state.hadLittleDingsAndTyreThings,
                hadScratchAndDent: ('hadScratchAndDent' in action.payload) ? action.payload.hadScratchAndDent : state.hadScratchAndDent,
                hadTyreAndRim: ('hadTyreAndRim' in action.payload) ? action.payload.hadTyreAndRim : state.hadTyreAndRim,
                isInEdit: ('isInEdit' in action.payload) ? action.payload.isInEdit : state.isInEdit,
                totalPremium: ('totalPremium' in action.payload) ? action.payload.totalPremium : state.totalPremium,
                hadRafAssist: ('hadRafAssist' in action.payload) ? action.payload.hadRafAssist : state.hadRafAssist,
                rafAssist: ('rafAssist' in action.payload) ? action.payload.rafAssist : state.rafAssist,
                selectedDriver: ('selectedDriver' in action.payload) ? action.payload.selectedDriver : state.selectedDriver,
                quoteType: ('quoteType' in action.payload) ? action.payload.quoteType : state.quoteType,
                portablePossessionTypeId: ('portablePossessionTypeId' in action.payload) ? action.payload.portablePossessionTypeId : state.portablePossessionTypeId,
                portablePossessionType: ('portablePossessionType' in action.payload) ? action.payload.portablePossessionType : state.portablePossessionType,
                portablePossessionDescription: ('portablePossessionDescription' in action.payload) ? action.payload.portablePossessionDescription : state.portablePossessionDescription,
                replacementValue: ('replacementValue' in action.payload) ? action.payload.replacementValue : state.replacementValue,
                startReplacementValue: ('startReplacementValue' in action.payload) ? action.payload.startReplacementValue : state.startReplacementValue,
                replacementCheckResult: ('replacementCheckResult' in action.payload) ? action.payload.replacementCheckResult : state.replacementCheckResult,
                MaxReplacementValue: ('MaxReplacementValue' in action.payload) ? action.payload.MaxReplacementValue : state.MaxReplacementValue,
                MinReplacementValue: ('MinReplacementValue' in action.payload) ? action.payload.MinReplacementValue : state.MinReplacementValue,
                portablePossessionlastClaim: ('portablePossessionlastClaim' in action.payload) ? action.payload.portablePossessionlastClaim : state.portablePossessionlastClaim,
                portableItemDetails: ('portableItemDetails' in action.payload) ? action.payload.portableItemDetails : state.portableItemDetails,
                blingItemDetails: ('blingItemDetails' in action.payload) ? action.payload.blingItemDetails : state.blingItemDetails,
                riskItemPhonenumber: ('riskItemPhonenumber' in action.payload) ? action.payload.riskItemPhonenumber : state.riskItemPhonenumber,
                portablePossessionMakeId: ('portablePossessionMakeId' in action.payload) ? action.payload.portablePossessionMakeId : state.portablePossessionMakeId,
                portablePossessionModelId: ('portablePossessionModelId' in action.payload) ? action.payload.portablePossessionModelId : state.portablePossessionModelId,
                portablePossessionMemoryTypeId: ('portablePossessionMemoryTypeId' in action.payload) ? action.payload.portablePossessionMemoryTypeId : state.portablePossessionMemoryTypeId,
                selectedPortableDetail: ('selectedPortableDetail' in action.payload) ? action.payload.selectedPortableDetail : state.selectedPortableDetail,
                selectedBlingDetail: ('selectedBlingDetail' in action.payload) ? action.payload.selectedBlingDetail : state.selectedBlingDetail,
                blingPremiums: ('blingPremiums' in action.payload) ? action.payload.blingPremiums : state.blingPremiums,
                blingTypeId: ('blingTypeId' in action.payload) ? action.payload.blingTypeId : state.blingTypeId,
                blingType: ('blingType' in action.payload) ? action.payload.blingType : state.blingType,
                blingDescription: ('blingDescription' in action.payload) ? action.payload.blingDescription : state.blingDescription,
                blingRisk: ('blingRisk' in action.payload) ? action.payload.blingRisk : state.blingRisk,
                blingMakeId: ('blingMakeId' in action.payload) ? action.payload.blingMakeId : state.blingMakeId,
                cellPhoneMemoryTypeId: ('cellPhoneMemoryTypeId' in action.payload) ? action.payload.cellPhoneMemoryTypeId : state.cellPhoneMemoryTypeId,
                cellPhoneModelId: ('cellPhoneModelId' in action.payload) ? action.payload.cellPhoneModelId : state.cellPhoneModelId,
                cellPhoneMakeId: ('cellPhoneMakeId' in action.payload) ? action.payload.cellPhoneMakeId : state.cellPhoneMakeId,
                serialNumber: ('serialNumber' in action.payload) ? action.payload.serialNumber : state.serialNumber,
                cellPhoneInitials: ('cellPhoneInitials' in action.payload) ? action.payload.cellPhoneInitials : state.cellPhoneInitials,
                cellPhoneSurname: ('cellPhoneSurname' in action.payload) ? action.payload.cellPhoneInitials : state.cellPhoneSurname,
                adminJudgementQuestions: ('adminJudgementQuestions' in action.payload) ? action.payload.adminJudgementQuestions : state.adminJudgementQuestions,
                adminJudgementAnswerSet: ('adminJudgementAnswerSet' in action.payload) ? action.payload.adminJudgementAnswerSet : state.adminJudgementAnswerSet,
                inceptionDate: ('inceptionDate' in action.payload) ? action.payload.inceptionDate : state.inceptionDate,
                firstPremium: ('firstPremium' in action.payload) ? action.payload.firstPremium : state.firstPremium,
                firstPremiumType: ('firstPremiumType' in action.payload) ? action.payload.firstPremiumType : state.firstPremiumType,
                firstPremiumDate: ('firstPremiumDate' in action.payload) ? action.payload.firstPremiumDate : state.firstPremiumDate,
                premiumTotal: ('premiumTotal' in action.payload) ? action.payload.premiumTotal : state.premiumTotal,
                bankName: ('bankName' in action.payload) ? action.payload.bankName : state.bankName,
                accountNumber: ('accountNumber' in action.payload) ? action.payload.accountNumber : state.accountNumber,
                bankError: ('bankError' in action.payload) ? action.payload.bankError : state.bankError,
                branchId: ('branchId' in action.payload) ? action.payload.branchId : state.branchId,
                bankId: ('bankId' in action.payload) ? action.payload.bankId : state.bankId,
                bankAccountTypeId: ('bankAccountTypeId' in action.payload) ? action.payload.bankAccountTypeId : state.bankAccountTypeId,
                referralResponse: ('referralResponse' in action.payload) ? action.payload.referralResponse : state.referralResponse,
                validationErrorLegalQuestions: ('validationErrorLegalQuestions' in action.payload) ? action.payload.validationErrorLegalQuestions : state.validationErrorLegalQuestions,
                isQuoteScreen: ('isQuoteScreen' in action.payload) ? action.payload.isQuoteScreen : state.isQuoteScreen,
                quoteScreenRiskId: ('quoteScreenRiskId' in action.payload) ? action.payload.quoteScreenRiskId : state.quoteScreenRiskId,
                quoteScreenRiskDescription: ('quoteScreenRiskDescription' in action.payload) ? action.payload.quoteScreenRiskDescription : state.quoteScreenRiskDescription,
                acceptedBlingCovers: ('acceptedBlingCovers' in action.payload) ? action.payload.acceptedBlingCovers : state.acceptedBlingCovers,
                acceptBlingQuote: ('acceptBlingQuote' in action.payload) ? action.payload.acceptBlingQuote : state.acceptBlingQuote,
                addedBlingNumbers: ('addedBlingNumbers' in action.payload) ? action.payload.addedBlingNumbers : state.addedBlingNumbers,
                iMEINumber: ('iMEINumber' in action.payload) ? action.payload.iMEINumber : state.iMEINumber,
                isIMEINumberActive: ('isIMEINumberActive' in action.payload) ? action.payload.isIMEINumberActive : state.isIMEINumberActive,
                regularDriverGender: ('regularDriverGender' in action.payload) ? action.payload.regularDriverGender : state.regularDriverGender,
                gender: ('gender' in action.payload) ? action.payload.gender : state.gender,
                sourceOfIncomeId: ('sourceOfIncomeId' in action.payload) ? action.payload.sourceOfIncomeId : state.sourceOfIncomeId,
                quoteCancellationReasons: ('quoteCancellationReasons' in action.payload) ? action.payload.quoteCancellationReasons : state.quoteCancellationReasons,
                primaryQuoteCancellationReason: ('primaryQuoteCancellationReason' in action.payload) ? action.payload.primaryQuoteCancellationReason : state.primaryQuoteCancellationReason,
                secondaryQuoteCancellationReason: ('secondaryQuoteCancellationReason' in action.payload) ? action.payload.secondaryQuoteCancellationReason : state.secondaryQuoteCancellationReason,
                updatedPremium: ('updatedPremium' in action.payload) ? action.payload.updatedPremium : state.updatedPremium,
                creditAmount: ('creditAmount' in action.payload) ? action.payload.creditAmount : state.creditAmount,
                isInRemove: ('isInRemove' in action.payload) ? action.payload.isInRemove : state.isInRemove,
                protectiveCase: ('protectiveCase' in action.payload) ? action.payload.protectiveCase : state.protectiveCase,
                saleStep: ('saleStep' in action.payload) ? action.payload.saleStep : state.saleStep,
                saleSubStep: ('saleSubStep' in action.payload) ? action.payload.saleSubStep : state.saleSubStep,
                selectedSalesStep: ('selectedSalesStep' in action.payload) ? action.payload.selectedSalesStep : state.selectedSalesStep,
                lastCompletedSubStep: ('lastCompletedSubStep' in action.payload) ? action.payload.lastCompletedSubStep : state.lastCompletedSubStep,
                carColor: ('carColor' in action.payload) ? action.payload.carColor : state.carColor,
                codeRedSelectedRiskitem: ('codeRedSelectedRiskitem' in action.payload) ? action.payload.codeRedSelectedRiskitem : state.codeRedSelectedRiskitem,
                vinNumber: ('vinNumber' in action.payload) ? action.payload.vinNumber : state.vinNumber,
                engineNumber: ('engineNumber' in action.payload) ? action.payload.engineNumber : state.engineNumber,
                kilometersOnCar: ('kilometersOnCar' in action.payload) ? action.payload.kilometersOnCar : state.kilometersOnCar,
                averageKilometers: ('averageKilometers' in action.payload) ? action.payload.averageKilometers : state.averageKilometers,
                carRegisteredLocally: ('carRegisteredLocally' in action.payload) ? action.payload.carRegisteredLocally : state.carRegisteredLocally,
                performanceModification: ('performanceModification' in action.payload) ? action.payload.performanceModification : state.performanceModification,
                fullServiceHistory: ('fullServiceHistory' in action.payload) ? action.payload.fullServiceHistory : state.fullServiceHistory,
                existingWarranty: ('existingWarranty' in action.payload) ? action.payload.existingWarranty : state.existingWarranty,
                selectedAgreedValue: ('selectedAgreedValue' in action.payload) ? action.payload.selectedAgreedValue : state.selectedAgreedValue,
                selectedAgreedValuePercentage: ('selectedAgreedValuePercentage' in action.payload) ? action.payload.selectedAgreedValuePercentage : state.selectedAgreedValuePercentage,
                warrantyBenefits: ('warrantyBenefits' in action.payload) ? action.payload.warrantyBenefits : state.warrantyBenefits,
                carWarrantyValueDisplay: ('carWarrantyValueDisplay' in action.payload) ? action.payload.carWarrantyValueDisplay : state.carWarrantyValueDisplay,
                carWarrantyMaxMilage: ('carWarrantyMaxMilage' in action.payload) ? action.payload.carWarrantyMaxMilage : state.carWarrantyMaxMilage,
                buildingLiving: ('buildingLiving' in action.payload) ? action.payload.buildingLiving : state.buildingLiving,
                buildingOwner: ('buildingOwner' in action.payload) ? action.payload.buildingOwner : state.buildingOwner,
                buildingStorage: ('buildingStorage' in action.payload) ? action.payload.buildingStorage : state.buildingStorage,
                buildingUse: ('buildingUse' in action.payload) ? action.payload.buildingUse : state.buildingUse,
                buildingAge: ('buildingAge' in action.payload) ? action.payload.buildingAge : state.buildingAge,
                buildingInfo: ('buildingInfo' in action.payload) ? action.payload.buildingInfo : state.buildingInfo,
                propertyBorders: ('propertyBorders' in action.payload) ? action.payload.propertyBorders : state.propertyBorders,
                buildingAdditional: ('buildingAdditional' in action.payload) ? action.payload.buildingAdditional : state.buildingAdditional,
                buildingAdditionalDetail: ('buildingAdditionalDetail' in action.payload) ? action.payload.buildingAdditionalDetail : state.buildingAdditionalDetail,
                requiresReferral: ('requiresReferral' in action.payload) ? action.payload.requiresReferral : state.requiresReferral,
                currentlyInsured: ('currentlyInsured' in action.payload) ? action.payload.currentlyInsured : state.currentlyInsured,
                claimsCount: ('claimsCount' in action.payload) ? action.payload.claimsCount : state.claimsCount,
                claimsHistory: ('claimsHistory' in action.payload) ? action.payload.claimsHistory : state.claimsHistory,
                buildingRating: ('buildingRating' in action.payload) ? action.payload.buildingRating : state.buildingRating,
                buildingReplacementValue: ('buildingReplacementValue' in action.payload) ? action.payload.buildingReplacementValue : state.buildingReplacementValue,
                buildingContinueQuote: ('buildingContinueQuote' in action.payload) ? action.payload.buildingContinueQuote : state.buildingContinueQuote,
                claimsSelection: ('claimsSelection' in action.payload) ? action.payload.claimsSelection : state.claimsSelection,
            }
        case SET_IVERI_DATA:
            return {
                ...state,
                iveriSubmissionUrl: ('iveriSubmissionUrl' in action.payload) ? action.payload.iveriSubmissionUrl : state.iveriSubmissionUrl,
                firebaseToken: ('firebaseToken' in action.payload) ? action.payload.firebaseToken : state.firebaseToken,
            }
        case NEW_QUOTE_CAR:
            return {
                ...state,
                carDetails: {},
                vehicleFullDescription: "",
                vehicleYear: "",
                vehicleMakeId: "",
                vehicleModelId: "",
                vehicleSeriesId: "",
                mmCode: "",
                regNr: "",
                financeHouse: "",
                financeHouseId: -1,
                addressId: null,
                addressDetail: { province: null, city: null, suburb: null, postalCode: null, formatted: null },
                address: "",
                lat: 0.00,
                lon: 0.00,
                regularDriver: "",
                regularDriverOtherName: "",
                regularDriverOtherSurname: "",
                regularDriverOtherIdNumber: "",
                regularDriverRelationship: "",
                selectedExcess: "",
                excessList: [],
                carPremium: "",
                proRata: 0.00,
                carId: "",
                carHireOptions: null,
                balloonOptions: null,
                magsAndRims: "",
                smashAndGrab: "",
                sunroof: "",
                leatherSeats: "",
                other: "",
                bullbar: "",
                canopy: "",
                accessoryValue: 0,
                carHire: null,
                creditShortfall: null,
                kingsCab: null,
                littleDingsAndTyreThings: null,
                scratchAndDent: null,
                tyreAndRim: null,
                tyreAndRimOptions: null,
                littleDingsOptions: null,
                bankOptions: "",
                branchOptions: "",
                isNewItem: true,
                hadBullbar: false,
                hadCanopy: false,
                hadCarRims: false,
                hadLeatherSeats: false,
                hadOtherAccesories: false,
                hadSmashGrab: false,
                hadSunroof: false,
                hadCarHire: false,
                hadCreditShortfall: false,
                hadKingsCab: false,
                hadLittleDingsAndTyreThings: false,
                hadScratchAndDent: false,
                hadTyreAndRim: false,
                isInEdit: false,
                totalPremium: "0.00",
                hadRafAssist: false,
                rafAssist: null,
                showRafAssist: false,
                selectedDriver: "",
                portablePossessionTypeId: "",
                portablePossessionType: "",
                portablePossessionDescription: "",
                replacementValue: 0,
                startReplacementValue: 0,
                replacementCheckResult: "",
                MaxReplacementValue: 0,
                MinReplacementValue: 0,
                riskItemPhonenumber: "",
                portablePossessionMakeId: "",
                portablePossessionModelId: "",
                portablePossessionMemoryTypeId: "",
                blingTypeId: 2,
                blingType: "",
                blingDescription: "",
                blingRisk: '',
                blingItemDetails: null,
                blingMakeId: "",
                cellPhoneMemoryTypeId: "",
                cellPhoneModelId: "",
                cellPhoneMakeId: "",
                serialNumber: "",
                cellPhoneInitials: "",
                cellphoneSurname: "",
                inceptionDate: "",
                firstPremium: "",
                firstPremiumType: "",
                firstPremiumDate: "",
                premiumTotal: "",
                bankName: "",
                accountNumber: "",
                bankError: false,
                bankAccountTypeId: "",
                bankId: "",
                branchId: "",
                isQuoteScreen: false,
                quoteScreenRiskId: "",
                quoteScreenRiskDescription: "",
                regularDriverGender: null,
                gender: null,
                sourceOfIncomeId: null,
                isInRemove: null,
                saleStep: 0,
                saleSubStep: 0,
                selectedSalesStep: { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: "Personal info", subTitle: "We need a few details" },
                salesStepConfiguration: {
                    steps:
                        []
                },
                nextSalesStep: 0,
                nextSalesSubStep: 0,
                lastCompletedStep: 0,
                lastCompletedSubStep: 0,
                carColor: null,
                codeRedSelectedRiskitem: "",
                kilometersOnCar: 0,
                averageKilometers: 0,
                vinNumber: "",
                engineNumber: "",
                carRegisteredLocally: undefined,
                performanceModification: undefined,
                fullServiceHistory: undefined,
                existingWarranty: undefined,
                selectedAgreedValue: undefined,
                selectedAgreedValuePercentage: 0,
                warrantyBenefits: [],
                carWarrantyValueDisplay: "",
                carWarrantyMaxMilage: "",
            }
        case RESET_QUOTE_DATA:
            return {
                ...state,
                product: "",
                KPCID: "",
                quote: {},
                carDetails: {},
                name: "",
                surname: "",
                cellphoneNumber: "",
                email: "",
                idNumber: "",
                itcConsent: false,
                mobileClientInfoStatus: "",
                policyId: "",
                customerId: "",
                quoteNumber: "",
                policyNumber: "",
                lmsStatus: false,
                bucketKey: "",
                referenceKey: "",
                vehicleFullDescription: "",
                vehicleYear: "",
                vehicleMakeId: "",
                vehicleModelId: "",
                vehicleSeriesId: "",
                mmCode: "",
                regNr: "",
                financed: undefined,
                financeHouse: "",
                financeHouseId: -1,
                addressId: null,
                addressDetail: { province: null, city: null, suburb: null, postalCode: null, formatted: null },
                address: "",
                lat: 0.00,
                lon: 0.00,
                regularDriver: "",
                regularDriverOtherName: "",
                regularDriverOtherSurname: "",
                regularDriverOtherIdNumber: "",
                regularDriverRelationship: "",
                quoteId: "",
                maritalStatus: '',
                carRisk: '',
                lastClaim: '',
                driversLicense: "",
                driversLicenseDate: "",
                selectedExcess: "",
                excessList: [],
                carPremium: "",
                proRata: 0.00,
                carId: "",
                coverId: "",
                carHireOptions: null,
                balloonOptions: null,
                magsAndRims: "",
                smashAndGrab: "",
                sunroof: "",
                leatherSeats: "",
                other: "",
                bullbar: "",
                canopy: "",
                accessoryValue: 0,
                carHire: null,
                creditShortfall: null,
                kingsCab: null,
                littleDingsAndTyreThings: null,
                scratchAndDent: null,
                tyreAndRim: null,
                tyreAndRimOptions: null,
                littleDingsOptions: null,
                firebaseToken: "",
                iveriSubmissionUrl: "",
                bankOptions: "",
                branchOptions: "",
                isNewItem: true,
                hadBullbar: false,
                hadCanopy: false,
                hadCarRims: false,
                hadLeatherSeats: false,
                hadOtherAccesories: false,
                hadSmashGrab: false,
                hadSunroof: false,
                hadCarHire: false,
                hadCreditShortfall: false,
                hadKingsCab: false,
                hadLittleDingsAndTyreThings: false,
                hadScratchAndDent: false,
                hadTyreAndRim: false,
                hadRafAssist: false,
                rafAssist: null,
                isInEdit: false,
                totalPremium: "0.00",
                showRafAssist: false,
                selectedDriver: "",
                portablePossessionTypeId: 0,
                portablePossessionType: "",
                portablePossessionDescription: "",
                replacementValue: 0,
                startReplacementValue: 0,
                replacementCheckResult: "",
                MaxReplacementValue: 0,
                MinReplacementValue: 0,
                portablePossessionRisk: '',
                portablePossessionlastClaim: '',
                portableItemDetails: null,
                blingItemDetails: null,
                riskItemPhonenumber: "",
                portablePossessionMakeId: "",
                portablePossessionModelId: "",
                portablePossessionMemoryTypeId: "",
                blingPremiums: [],
                adminJudgementQuestions: [],
                adminJudgementAnswerSet: emptyAnswers,
                referralResponse: "",
                validationErrorLegalQuestions: true,
                blingTypeId: 2,
                blingType: "",
                blingDescription: "",
                blingRisk: '',
                selectedBlingDetail: "",
                blingMakeId: "",
                cellPhoneMemoryTypeId: "",
                cellPhoneModelId: "",
                cellPhoneMakeId: "",
                serialNumber: "",
                cellPhoneInitials: "",
                cellPhoneSurname: "",
                inceptionDate: "",
                firstPremium: "",
                firstPremiumType: "",
                firstPremiumDate: "",
                premiumTotal: "",
                bankName: "",
                accountNumber: "",
                bankError: false,
                bankAccountTypeId: "",
                bankId: "",
                branchId: "",
                isIMEINumberActive: false,
                iMEINumber: "",
                isQuoteScreen: false,
                quoteScreenRiskId: "",
                quoteScreenRiskDescription: "",
                acceptedBlingCovers: [],
                addedBlingNumbers: [],
                acceptBlingQuote: null,
                regularDriverGender: null,
                gender: null,
                sourceOfIncomeId: null,
                primaryQuoteCancellationReason: null,
                secondaryQuoteCancellationReason: null,
                protectiveCase: 2,
                saleStep: 0,
                saleSubStep: 0,
                selectedSalesStep: { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: "Personal info", subTitle: "We need a few details" },
                salesStepConfiguration: {
                    steps:
                        []
                },
                nextSalesStep: 0,
                nextSalesSubStep: 0,
                lastCompletedStep: 0,
                lastCompletedSubStep: 0,
                carColor: null,
                codeRedSelectedRiskitem: "",
                kilometersOnCar: 0,
                averageKilometers: 0,
                vinNumber: "",
                engineNumber: "",
                carRegisteredLocally: undefined,
                performanceModification: undefined,
                fullServiceHistory: undefined,
                existingWarranty: undefined,
                selectedAgreedValue: undefined,
                selectedAgreedValuePercentage: 0,
                warrantyBenefits: [],
                carWarrantyValueDisplay: "",
                carWarrantyMaxMilage: "",
                buildingLiving: '',
                buildingOwner: false,
                buildingStorage: false,
                buildingUse: "",
                buildingAge: -1,
                buildingInfo: { bedrooms: 0, geysers: 0, securityEstate: false, armedResponse: false, burglarBars: false, electricFence: false },
                propertyBorders: { field: false, river: false, informalSettlement: false, farmPlot: false },
                buildingAdditional: { thatchRoof: false, thatchLapa: false, alternativePower: false, woodenWalls: false },
                buildingAdditionalDetail: { thatch_lightningConductor: false, thatch_fireExtinguisher: false, thatch_fireRetardantTreatment: false, thatch_harveyTiles: false, thatch_distanceBetween: null, alternativePower_replacementValue: null },
                requiresReferral: false,
                currentlyInsured: undefined,
                claimsCount: undefined,
                claimsSelection: undefined,
                claimsHistory: [],
                buildingRating: "",
                buildingReplacementValue: undefined,
                buildingContinueQuote: false,
            }
        case SET_STEPS_CODE_RED:
            return {
                ...state,
                nextSalesStep: ('nextSalesStep' in action.payload) ? action.payload.nextSalesStep : state.nextSalesStep,
                saleStep: 1,
                saleSubStep: 1,
                selectedSalesStep: { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: "Personal info" },
                lastCompletedSubStep: ('lastCompletedSubStep' in action.payload) ? action.payload.lastCompletedSubStep : state.lastCompletedSubStep,
                salesStepConfiguration: {
                    steps: [
                        { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: "Personal info" },
                        { maxSubSteps: 1, stepLabel: 2, step: 2, subStep: 1, maxMobileSubSteps: 1, title: "Credit history" },
                        { maxSubSteps: 2, stepLabel: 3, step: 3, subStep: 1, maxMobileSubSteps: 2, title: "Travel by vehicle" },
                        { maxSubSteps: 1, stepLabel: 4, step: 4, subStep: 1, maxMobileSubSteps: 1, title: "Vehicle details" },
                    ]
                },
                mmCode: "",
                vehicleYear: "",
                vehicleMakeId: "",
                vehicleModelId: "",
                vehicleSeriesId: "",
                carColor: "",
                regNr: "",
                vehicleFullDescription: "",
                codeRedSelectedRiskitem: "",
            }
        case SET_STEPS_WARRANTY:
            return {
                ...state,
                nextSalesStep: ('nextSalesStep' in action.payload) ? action.payload.nextSalesStep : state.nextSalesStep,
                saleStep: 1,
                saleSubStep: 1,
                selectedSalesStep: { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: "Personal info" },
                lastCompletedSubStep: ('lastCompletedSubStep' in action.payload) ? action.payload.lastCompletedSubStep : state.lastCompletedSubStep,
                salesStepConfiguration: {
                    steps: [
                        { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: "Personal info" },
                        { maxSubSteps: 1, stepLabel: 2, step: 2, subStep: 1, maxMobileSubSteps: 1, title: "Credit history" },
                        { maxSubSteps: 1, stepLabel: 3, step: 3, subStep: 1, maxMobileSubSteps: 1, title: "Warranty questions" },
                        { maxSubSteps: 1, stepLabel: 4, step: 4, subStep: 1, maxMobileSubSteps: 1, title: "Reg nr. lookup" },
                        { maxSubSteps: 1, stepLabel: 5, step: 5, subStep: 1, maxMobileSubSteps: 1, title: "Car make" },
                        { maxSubSteps: 1, stepLabel: 6, step: 6, subStep: 1, maxMobileSubSteps: 1, title: "Car details" },
                        { maxSubSteps: 1, stepLabel: 7, step: 7, subStep: 1, maxMobileSubSteps: 1, title: "Kilometers on car" },
                        { maxSubSteps: 1, stepLabel: 8, step: 8, subStep: 1, maxMobileSubSteps: 1, title: "Average kilometers" },
                        { maxSubSteps: 1, stepLabel: 9, step: 9, subStep: 1, maxMobileSubSteps: 1, title: "Warranty disclaimer" },
                    ]
                },
                mmCode: "",
                vehicleYear: "",
                vehicleMakeId: 0,
                vehicleModelId: 0,
                vehicleSeriesId: 0,
                regNr: "",
                vinNumber: "",
                engineNumber: "",
                vehicleFullDescription: "",
                kilometersOnCar: 0,
                averageKilometers: 0,
                carRegisteredLocally: undefined,
                performanceModification: undefined,
                fullServiceHistory: undefined,
                existingWarranty: undefined,
            }
        case SET_STEPS_BUILDING:
        case SET_STEPS_HOME_CONTENT:
            return {
                ...state,
                buildingContinueQuote: false,
                nextSalesStep: ('nextSalesStep' in action.payload) ? action.payload.nextSalesStep : state.nextSalesStep,
                saleStep: 1,
                saleSubStep: 1,
                selectedSalesStep: { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: "Personal info" },
                lastCompletedSubStep: ('lastCompletedSubStep' in action.payload) ? action.payload.lastCompletedSubStep : state.lastCompletedSubStep,
                salesStepConfiguration: {
                    steps: [
                        { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: "Personal info" },
                        { maxSubSteps: 1, stepLabel: 2, step: 2, subStep: 1, maxMobileSubSteps: 1, title: "Credit history" },
                        { maxSubSteps: 2, stepLabel: 3, step: 3, subStep: 1, maxMobileSubSteps: 2, title: "Address selection" },
                        { maxSubSteps: 2, stepLabel: 4, step: 4, subStep: 1, maxMobileSubSteps: 2, title: "Owner or tenant" },
                        { maxSubSteps: 1, stepLabel: 5, step: 5, subStep: 1, maxMobileSubSteps: 1, title: "Building use" },
                        { maxSubSteps: 1, stepLabel: 6, step: 6, subStep: 1, maxMobileSubSteps: 1, title: "Building age" },
                        { maxSubSteps: 1, stepLabel: 7, step: 7, subStep: 1, maxMobileSubSteps: 1, title: "Property info" },
                        { maxSubSteps: 1, stepLabel: 8, step: 8, subStep: 1, maxMobileSubSteps: 1, title: "Property borders" },
                        { maxSubSteps: 3, stepLabel: 9, step: 9, subStep: 1, maxMobileSubSteps: 3, title: "Building details" },
                        { maxSubSteps: 1, stepLabel: 10, step: 10, subStep: 1, maxMobileSubSteps: 1, title: "Insurance history" },
                        { maxSubSteps: 2, stepLabel: 11, step: 11, subStep: 1, maxMobileSubSteps: 2, title: "Claims history" },
                        { maxSubSteps: 1, stepLabel: 12, step: 12, subStep: 1, maxMobileSubSteps: 1, title: "Property rating" },
                        { maxSubSteps: 1, stepLabel: 13, step: 13, subStep: 1, maxMobileSubSteps: 1, title: "Replacement value" },
                    ]
                },
            }
        case SET_STEPS_BUILDING_PARTIAL:
        case SET_STEPS_HOME_CONTENT_PARTIAL: {
            return {
                ...state,
                buildingContinueQuote: true,
                nextSalesStep: ('nextSalesStep' in action.payload) ? action.payload.nextSalesStep : state.nextSalesStep,
                saleStep: 1,
                saleSubStep: 1,
                selectedSalesStep: { maxSubSteps: 2, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 2, title: "Claims history" },
                lastCompletedSubStep: ('lastCompletedSubStep' in action.payload) ? action.payload.lastCompletedSubStep : state.lastCompletedSubStep,
                salesStepConfiguration: {
                    steps: [
                        { maxSubSteps: 2, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 2, title: "Claims history" },
                        { maxSubSteps: 1, stepLabel: 2, step: 2, subStep: 1, maxMobileSubSteps: 1, title: "Replacement value" },
                    ]
                },
            }
        }
        default:
            return state
    }
}
export default salesReducer